import React from "react";
import "./FullLayout.css";

function FullLayout({ children }) {
  return <div className="bg-full">{children}</div>;
}

export default FullLayout;
